const UploadButton = () => {
  const button = document.querySelector('.js-upload-button')
  const uploadText = document.querySelector('.js-upload-content')
  const reset = document.querySelector('.js-upload-reset')
  if (button) {
    button.addEventListener('change', event => {
      if (button.files.length > 0) {
        const size = [...button.files]
          .map(file => file.size)
          .reduce((a, b) => a + b)

        if (size > 15000000) {
          window.alert(
            `${
              button.files.length > 1
                ? 'De bestanden zijn samen'
                : 'Het bestand is'
            } groter dan 15MB, probeer kleinere bestanden te versturen.`
          )

          button.value = ''
          uploadText.innerHTML = 'Selecteer een kleiner bestand.'

          return
        }

        uploadText.innerHTML = `${button.files.length} ${
          button.files.length > 1 ? 'bestanden' : 'bestand'
        } geselecteerd`

        ;[...button.files].forEach(file => {
          const fileName = document.createElement('div')
          fileName.setAttribute('class', 'c-input__file')
          fileName.innerHTML = file.name
        })
      }
    })

    if(reset){
      reset.addEventListener('click', event => {
        reset.classList.add("c-input__upload-reset--inactive");
        button.value = "";
        uploadText.innerHTML = "Upload je bestand(en)";
      })
    }
  }
}

export default UploadButton



// WEBPACK FOOTER //
// ./src/js/modules/UploadButton.js